// extracted by mini-css-extract-plugin
export default {"main_con":"ticketStyles_main_con__pDW6p","account_card":"ticketStyles_account_card__GCCKZ","chat_card":"ticketStyles_chat_card__zC-FI"};